/* This file is autogenerated, see readme.md for instructions */
import PoverButtonSvgIcon from '@bloomreach/banana-theme/icons/pover-button.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PoverButtonIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PoverButtonSvgIcon />
    </Icon>
  );
});

PoverButtonIcon.displayName = 'PoverButtonIcon';

export default PoverButtonIcon;
